<template lang="pug">
  div.map-context.map-context-object.map-object-create
    ul.obj
      li(@click.prevent.stop="create('mps')").obj-mps МПС (МПП)
      li(@click.prevent.stop="create('mmco')").obj-mmtzoo ММЦОО
      li(@click.prevent.stop="create('save')").obj-storage Объект хранения
      li(@click.prevent.stop="create('bur')").obj-burial Объект захоронения
      li(@click.prevent.stop="create('proc')").obj-processing Объект обработки
      li(@click.prevent.stop="create('util')").obj-utilization Объект утилизации
      li(@click.prevent.stop="create('neutral')").obj-neutralization Объект обезвреживания
      li(@click.prevent.stop="create('bur')").obj-mercury Объект обработки ртутных ламп
</template>

<script>
import permissionMixin from '@/mixins/permission-mixin'
import url from '@/utils/url'
import mapContextMixin from '../mixins/map-context-mixin'

const actionCardMap = {
  mps: {
    name: 'geo.forecasts.object',
    fields: {
      is_mps: 1,
    },
  },
  mmco: {
    name: 'geo.forecasts.object',
    fields: {
      is_intermunicipal: 1,
    },
  },
  save: {
    name: 'geo.forecasts.object',
    fields: {
      tkoActions: [4],
    },
  },
  bur: {
    name: 'geo.forecasts.object',
    fields: {
      tkoActions: [6],
    },
  },
  proc: {
    name: 'geo.forecasts.object',
    fields: {
      tkoActions: [2],
    },
  },
  util: {
    name: 'geo.forecasts.object',
    fields: {
      tkoActions: [5],
    },
  },
  neutral: {
    name: 'geo.forecasts.object',
    fields: {
      tkoActions: [3],
    },
  },
}

export default {
  name: 'map-context-object',
  mixins: [mapContextMixin, permissionMixin],
  methods: {
    create(type) {
      let name = actionCardMap[type].name
      /* if (this.userHavePermissionEx(PERMS.CREATE) === false) {
          this.closeMenu()
          return false
        } */
      let params = {}
      let query = {}
      let fields = actionCardMap[type].fields || {}
      let disableFields = ['status_id' /*, 'location' */]
      if (this.model && this.model.id) {
        name += '.update'
        params.id = this.model.id
        query.setDisabled = JSON.stringify(disableFields)
      } else {
        name += '.create'
        query.setDisabled = JSON.stringify(disableFields)
        fields.latitude = this.latlng.lat
        fields.longitude = this.latlng.lng
        fields.status_id = 3
        fields.address = ''
        query.setFields = JSON.stringify(fields)
      }
      query.prevRoute = url.getRoute(
        this.$sharedServices.router.history.current,
        true
      )

      // for disable reload data on map
      this.$sharedServices.store.commit('skipAsyncData', {
        name: name,
        value: true,
      })

      this.closeMenu()

      this.$sharedServices.router.push({
        name: name,
        params: params,
        query: query,
      })
    },
  },
}
</script>
